import React from "react";
import style from "./style.module.css";
import HeroSlider from "../../other-components/HeroSlider/Slider";

function Modal({ title, description, data, spaceAbove }) {
    const images = data.map(item => item.item_media);

    return (
        <div className={`${style.parentView} ${spaceAbove ? style.space1X : ''}`}>
            {title ?
                <div className={style.headerView}>
                    <h2>{title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                : null
            }

            <div className={[style.contentsView].join(" ")}>
                <HeroSlider images={images} />
            </div>
        </div>
    );
}

export default Modal;